import { Divider, Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';

const ViewReservationsOverviewSkeleton = () => {
    return (
        <Box width="100%">
            <Grid container spacing={2} mb={4}>
                {/* Status Section */}
                <Grid size={{ xs: 12, sm: 2.2 }}>
                    <Skeleton variant="rectangular" width="40%" height={10} />
                    <Box mt={1}>
                        <Skeleton variant="rounded" width="50%" height={30} />
                    </Box>
                </Grid>

                <Grid size={{ xs: 12, sm: 3 }}>
                    <Box mb={2}>
                        <Skeleton width="60%" />
                    </Box>
                    <Box mb={2}>
                        <Skeleton width="60%" />
                    </Box>
                </Grid>

                <Grid size={{ xs: 12, sm: 2 }}>
                    <Box mb={2}>
                        <Skeleton width="40%" />
                    </Box>
                    <Box mb={2}>
                        <Skeleton width="40%" />
                    </Box>
                </Grid>

                <Grid size={{ xs: 12, sm: 3 }}>
                    <Box mb={2}>
                        <Skeleton width="60%" />
                    </Box>
                    <Box mb={2}>
                        <Skeleton width="60%" />
                    </Box>
                </Grid>

                <Grid size={{ xs: 12, sm: 1.8 }}>
                    <Skeleton variant="rounded" width="80%" height={55} />
                </Grid>
            </Grid>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={2} mb={3}>
                {[...Array(6)].map((_, index) => (
                    <Grid key={index} size={{ xs: 12, sm: 2 }}>
                        <Box mb={2}>
                            <Skeleton width="80%" />
                        </Box>
                        <Box mb={2}>
                            <Skeleton width="80%" />
                        </Box>
                    </Grid>
                ))}
            </Grid>

            <Divider sx={{ mb: 3 }} />

            <Box mb={3}>
                <Skeleton variant="rectangular" width="100%" height={48} />
                <Box mt={2}>
                    <Grid container spacing={2}>
                        <Grid size={6}>
                            <Skeleton variant="rectangular" width="100%" height={200} />
                        </Grid>
                        <Grid size={6}>
                            <Skeleton variant="rectangular" width="100%" height={200} />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Box mb={3}>
                <Skeleton variant="rectangular" width="100%" height={48} />
                <Box mt={2}>
                    <Skeleton variant="rectangular" width="100%" height={100} />
                </Box>
            </Box>

            <Grid size={12} mt={5}>
                <Skeleton variant="rectangular" width={100} height={36} />
            </Grid>
        </Box>
    );
};

export default ViewReservationsOverviewSkeleton;